import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, onBeforeUnmount, ref } from 'vue';
    import { Input } from '@/components/ui/input';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'DebouncedInput',
  props: {
        modelValue: {
            type: [String, Number],
            required: true,
        },
        debounce: {
            type: Number,
            default: 500,
        },
    },
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

    const props = __props;

    const emit = __emit;

    const timeout = ref<ReturnType<typeof setTimeout>>();

    const localValue = computed({
        get() {
            return props.modelValue;
        },
        set(newValue) {
            if (timeout.value) {
                clearTimeout(timeout.value);
            }
            timeout.value = setTimeout(() => emit('update:modelValue', newValue), props.debounce);
        },
    });
    onBeforeUnmount(() => clearTimeout(timeout.value));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Input), _mergeProps({
    class: "w-full min-w-20",
    modelValue: localValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localValue).value = $event))
  }, _ctx.$attrs), null, 16, ["modelValue"]))
}
}

})